module.exports = __webpack_public_path__ + "static/media/goodTimes.4f4351bd.jpeg";